import { useCallback, useState } from "react"

import { isEmail, useForm } from "@mantine/form"
import { sendPasswordResetEmail } from "firebase/auth"

import { firebase } from "../../../../services/firebase/firebase"
import { useLanguage } from "../../../../contexts/language-context"

export default (onClose: () => void) => {
    const [loading, setLoading] = useState(false)
    const { L } = useLanguage()
    const form = useForm({
        initialValues: { email: "" },
        validate: { email: isEmail(L("Must be a valid email address")) },
    })

    const sendRecovery = useCallback(
        async (values: typeof form.values) => {
            setLoading(true)
            await sendPasswordResetEmail(firebase.auth, values.email).catch(console.error)
            setLoading(false)
            onClose()
        },
        [form, onClose],
    )

    return { form, sendRecovery, loading }
}
